<ngx-slick-carousel class="topic-carousel" [config]="slideConfig">
  <ng-container *ngFor="let faq of faqList; let i = index">
    <div class="topic-carousel__item" ngxSlickItem>
      <app-topic-card
        [topic]="faq"
        (click)="handleFaqClick(faq)"
        (onEdit)="handleEditTopic(faq)"
        (onDelete)="handleDeleteTopic($event)"
        [menuOpen]="menuOpenIndex === i"
        (onMenuOpen)="handleMenuOpen(i)"
        (closeMenuEmitter)="closeAllMenu(i)"
        [selectedTopicId]="selectedTopic?.id || ''"
      ></app-topic-card>
    </div>
  </ng-container>
</ngx-slick-carousel>

<ng-container *ngIf="showDelteConfirmation">
  <app-confirmation-modal
    primaryButtonText="Cancel"
    secondaryButtonText="Yes"
    message="Are you sure you want to delete this Topic ?"
    caption="Delete Confirmation"
    (onPrimaryButtonClick)="toggleDeleteModal(false)"
    (onSecondaryButtonClick)="deleteTopic()"
    [secondaryButtonLoading]="deleteLoading"
  ></app-confirmation-modal>
</ng-container>
